import * as React from "react";

export class LeagueLabel extends React.PureComponent<{
    className: string,
    text?: string
}, {}>{
    render() {
        return (
            <div className={this.props.className} data-uat="div-league-label">
                {this.props.text}
            </div>
        )
    }
}